<div class="progressbar">
    <div class="progressbar__wrapper" [style.width]="percentage">
        <div class="progressbar__tooltip"><span>{{tooltip}}</span></div>
        <i class="fas fa-sort-down progressbar__icon" aria-hidden="true"></i>
    </div>
</div>